<div>
  @if (hasPastDue && pastDueEnabled) {
    <div class="row past-due-row-warning">
      <div class="column twelve past-due-column-warning">
        <span class="icon-alert"></span>
        <span
          data-cy="pastDueSeparatelyWarning"
          class="pad-left-10"
          dsContent
          [contentPath]="'billing.pastDueSeparately'"
        ></span>
      </div>
    </div>
  }
  <div class="row pad-top-20">
    <div class="column twelve">
      <p dsContent [contentPath]="'billing.getStartedPaymentDescription'"></p>

      @if (showSchedluePaymentBtn$ | async) {
        <button
          ds-button
          authCheck
          [permissionName]="'makemyacctpayment_walkthrough'"
          [checkAction]="'disable'"
          class="-outline float-right"
          (click)="registerAndNavigate(false, true)"
          data-cy="scheduleAPaymentButton"
          [attr.aria-label]="getStartedPaymentBtnContent"
        >
          {{ getStartedPaymentBtnContent }}
        </button>
      }

      @if ((billacountsEligibleForAutoPay$ | async)?.length > 0) {
        <button
          ds-button
          authCheck
          [disabled]="(billacountsEligibleForAutoPay$ | async)?.length > 6"
          [permissionName]="'makeautopayrule_walkthrough'"
          [checkAction]="'disable'"
          class="-outline-white float-right margin-right-20"
          type="button"
          [dsAnalyticsClick]="multiAutopayBillingSectionAnalytic.link"
          (click)="registerAndNavigate(true, false)"
          data-cy="setUpAutopayButton"
          aria-label="Set Up AutoPay"
        >
          Set Up AutoPay
        </button>
      }
    </div>
  </div>
</div>
